export default {
  zh: {
    notLogin:'请登录再进行游戏',
    notGame:'没有这个游戏',
    noJs:'请打开Javascript支持',
    notNetwork:'您没有连接网络，请不要退出游戏，连接网络后才能保存游戏进度',
    tokenErr:'账号在其他地方登录或者被封禁，您的游戏进度不会被保存',
    back:'退出',
    haveGold:'您有AAA金币',
    noExchange:'请注意，金币可以变为游戏币，但游戏币不能变为金币',
    cancel:'取消',
    submit:'兑换',
    restart:'兑换以后，游戏将会马上自动重启',
    weekRank:'周排行榜',
    wealthRank:'财富榜',
    scoreRank:'积分榜',
    reward:"奖励",
    noreward:"这个游戏没有竞赛奖励",
    rewardR:"奖励根据积分排行榜",
    carromScoreRule:"积分等于用户获得的游戏币，排除充值",
  },
  en: {
    notLogin:'Please log in to play the game',
    notGame:'no this game',
    noJs:'Please enable Javascript in your browser to play Game!',
    notNetwork:'No network, do not exit the game, the game progress can only be saved after connecting to the network',
    tokenErr:'Account is logged in elsewhere or banned, your game progress will not be saved',
    back:'Exit',
    haveGold:'you have AAA gold coins',
    noExchange:'Note that gold coins can be turned into game coins, but game coins cannot be turned into gold coins',
    cancel:'Cancel',
    submit:'Exchange',
    restart:'The game will restart after exchange',
    weekRank:'Weekly Rank',
    wealthRank:'Wealth',
    scoreRank:'Score',
    reward:"Reward",
    noreward:"There are no rewards in this game",
    rewardR:"Rewards are based on the score rank",
    carromScoreRule:"The score are according to the game coins, excluding excharge",
  },
  ar: {
    notLogin:'الرجاء تسجيل الدخول للعب اللعبة',
    notGame:'لا هذه اللعبة',
    noJs:'الرجاء تمكين Javascript في متصفحك للعب اللعبة!',
    notNetwork:'لا توجد شبكة ، لا تخرج من اللعبة ، لا يمكن حفظ تقدم اللعبة إلا بعد الاتصال بالشبكة',
    tokenErr:'تم تسجيل الدخول إلى الحساب في مكان آخر أو تم حظره ، ولن يتم حفظ تقدم اللعبة',
    back:'مخرج',
    haveGold:'لديك عملات ذهبية AAA',
    noExchange:'لاحظ أنه يمكن تحويل العملات الذهبية إلى عملات معدنية للعبة ، لكن لا يمكن تحويل عملات اللعبة إلى عملات ذهبية',
    cancel:'يلغي',
    submit:'تبادل',
    restart:'ستتم إعادة تشغيل اللعبة بعد التبادل',
    weekRank:'الترتيب الشهري',
    wealthRank:'رتبة الثروة',
    scoreRank:'رتبة النتيجة',
    reward:"جائزة",
    noreward:"لا توجد مكافآت في هذه اللعبة",
    rewardR:"تعتمد المكافآت على تصنيف النقاط",
    carromScoreRule:"النتيجة وفقا لعملات اللعبة ، باستثناء الشحن",
  },
  tr: {
    notLogin:'Oyunu oynamak için lütfen giriş yapın',
    notGame:'hayır bu oyun',
    noJs:'Oyun oynamak için lütfen tarayıcınızda Javascript\'i etkinleştirin!',
    notNetwork:'Ağ yok, oyundan çıkmayın, oyun ilerlemesi ancak ağa bağlandıktan sonra kaydedilebilir',
    tokenErr:'Hesap başka bir yerde oturum açtıysa veya yasaklandı, oyundaki ilerlemeniz kaydedilmeyecek',
    back:'çıkış',
    haveGold:'AAA altın paranız var',
    noExchange:'Altın paraların oyun parasına dönüştürülebileceğini, ancak oyun paralarının altın paraya dönüştürülemeyeceğini unutmayın.',
    cancel:'İptal',
    submit:'Değiş tokuş',
    restart:'Değişimden sonra oyun yeniden başlayacak',
    weekRank:'الترتيب الشهري',
    wealthRank:'zenginlik sıralaması',
    scoreRank:'puan sıralaması',
    reward:"Ödül",
    noreward:"Bu oyunda ödül yok",
    rewardR:"Ödüller puan sıralamasına göre belirlenir",
    carromScoreRule:"Skor, boşaltma hariç oyun jetonlarına göredir.",
  },
  pt: {
    notLogin: "Por favor, faça login para jogar o jogo",
    notGame: "não há este jogo",
    noJs: "Por favor, ative o Javascript no seu navegador para jogar o jogo!",
    notNetwork: "Sem rede, não saia do jogo, o progresso do jogo só pode ser salvo após conectar-se à rede",
    tokenErr: "A conta está logada em outro lugar ou banida, o seu progresso no jogo não será salvo",
    back: "Sair",
    haveGold: "você tem AAA moedas de ouro",
    noExchange: "Observe que as moedas de ouro podem ser convertidas em moedas do jogo, mas as moedas do jogo não podem ser convertidas em moedas de ouro",
    cancel: "Cancelar",
    submit: "Trocar",
    restart: "O jogo será reiniciado após a troca",
    weekRank: "Ranking Semanal",
    wealthRank: "Riqueza",
    scoreRank: "Pontuação",
    reward: "Recompensa",
    noreward: "Não há recompensas neste jogo",
    rewardR: "As recompensas são baseadas no ranking de pontuação",
    carromScoreRule: "A pontuação é de acordo com as moedas do jogo, excluindo a troca"
  },
  id: {
    notLogin: "Silakan masuk untuk bermain game",
    notGame: "tidak ada game ini",
    noJs: "Harap aktifkan Javascript di browser Anda untuk memainkan game!",
    notNetwork: "Tidak ada jaringan, jangan keluar dari game, progres game hanya dapat disimpan setelah terhubung ke jaringan",
    tokenErr: "Akun sedang masuk di tempat lain atau diblokir, progres game Anda tidak akan disimpan",
    back: "Keluar",
    haveGold: "Anda memiliki AAA koin emas",
    noExchange: "Perhatikan bahwa koin emas dapat diubah menjadi koin game, tetapi koin game tidak dapat diubah menjadi koin emas",
    cancel: "Batal",
    submit: "Tukar",
    restart: "Game akan dimulai ulang setelah penukaran",
    weekRank: "Peringkat Mingguan",
    wealthRank: "Kekayaan",
    scoreRank: "Skor",
    reward: "Hadiah",
    noreward: "Tidak ada hadiah dalam game ini",
    rewardR: "Hadiah didasarkan pada peringkat skor",
    carromScoreRule: "Skor dihitung berdasarkan koin game, tidak termasuk penukaran"
  },
  uz: {
    notLogin: "Iltimos, o'yinni o'ynash uchun tizimga kiring",
    notGame: "bunday o'yin mavjud emas",
    noJs: "Iltimos, o'yinni o'ynash uchun brauzeringizda Javascriptni yoqing!",
    notNetwork: "Tarmoq yo'q, o'yindan chiqmang, o'yin progresi faqat tarmoqqa ulanandan keyin saqlanadi",
    tokenErr: "Hisob boshqa joyda kirilgan yoki taqiqlangan, o'yin progresingiz saqlanmaydi",
    back: "Chiqish",
    haveGold: "Sizda AAA oltin tanga bor",
    noExchange: "Diqqat: oltin tangalar o'yin tangalariga aylantirilishi mumkin, ammo o'yin tangalari oltin tangalarga aylantirilmaydi",
    cancel: "Bekor qilish",
    submit: "Aylantirish",
    restart: "O'yin aylantirishdan so'ng qayta ishga tushadi",
    weekRank: "Haftalik Reyting",
    wealthRank: "Boylik",
    scoreRank: "Reyting",
    reward: "Mukofot",
    noreward: "Bu o'yinda mukofot yo'q",
    rewardR: "Mukofotlar reytingga asoslanadi",
    carromScoreRule: "Ballar o'yin tangalariga qarab hisoblanadi, ayirboshlash hisobga olinmaydi"
  },
  ru: {
    notLogin: "Пожалуйста, войдите в игру, чтобы играть",
    notGame: "такой игры нет",
    noJs: "Пожалуйста, включите Javascript в вашем браузере для игры!",
    notNetwork: "Нет сети, не выходите из игры, прогресс игры может быть сохранен только после подключения к сети",
    tokenErr: "Аккаунт залогинен в другом месте или заблокирован, ваш прогресс в игре не будет сохранен",
    back: "Выход",
    haveGold: "У вас есть AAA золотых монет",
    noExchange: "Обратите внимание, что золотые монеты можно обменять на игровые монеты, но игровые монеты нельзя обменять на золотые монеты",
    cancel: "Отмена",
    submit: "Обменять",
    restart: "Игра перезапустится после обмена",
    weekRank: "Еженедельный рейтинг",
    wealthRank: "Богатство",
    scoreRank: "Оценка",
    reward: "Награда",
    noreward: "В этой игре нет наград",
    rewardR: "Награды зависят от рейтинга",
    carromScoreRule: "Оценка зависит от игровых монет, исключая обмен"
  },
  fa: {
    notLogin: "لطفاً برای بازی وارد شوید",
    notGame: "این بازی وجود ندارد",
    noJs: "لطفاً جاوا اسکریپت را در مرورگر خود برای بازی فعال کنید!",
    notNetwork: "بدون شبکه، از بازی خارج نشوید، پیشرفت بازی فقط پس از اتصال به شبکه ذخیره می‌شود",
    tokenErr: "حساب در جای دیگری وارد شده یا مسدود شده است، پیشرفت بازی شما ذخیره نخواهد شد",
    back: "خروج",
    haveGold: "شما AAA سکه طلای دارید",
    noExchange: "توجه داشته باشید که سکه‌های طلا می‌توانند به سکه‌های بازی تبدیل شوند، اما سکه‌های بازی نمی‌توانند به سکه‌های طلا تبدیل شوند",
    cancel: "لغو",
    submit: "تبادل",
    restart: "بازی پس از تبادل دوباره شروع خواهد شد",
    weekRank: "رتبه هفتگی",
    wealthRank: "ثروت",
    scoreRank: "امتیاز",
    reward: "پاداش",
    noreward: "در این بازی پاداشی وجود ندارد",
    rewardR: "پاداش‌ها بر اساس رتبه امتیاز هستند",
    carromScoreRule: "امتیازها بر اساس سکه‌های بازی محاسبه می‌شوند، بدون در نظر گرفتن تبادل"
  }
}


// WEBPACK FOOTER //
// src/pages/app/gotowallet/lang.js